window.addEventListener("DOMContentLoaded", () => {
  removeEnter();
  AOS.init({
    duration: 1000,
    easing: "ease-in-out-quad",
    once: true,
  });
});

function removeEnter() {
  let t = document.querySelector(".brand");
  t.innerHTML = t.innerHTML.replaceAll("&nbsp;", "");
}

function detectMobileDevice(agent) {
  const mobileRegex = [
    /Android/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  return mobileRegex.some((mobile) => agent.match(mobile));
}
 
function getSectionHeight(section) {
  const sectionRect = section.getBoundingClientRect();
  return sectionRect.height;
}
 
function isSectionVisible(section) {
  const sectionRect = section.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  // 요소가 화면에 보이는지 여부를 계산
  const isFullyVisible =
    sectionRect.top >= 0 && sectionRect.bottom <= windowHeight;
  const isPartiallyVisible =
    sectionRect.top < windowHeight && sectionRect.bottom >= 0;

  return isFullyVisible || isPartiallyVisible;
} 

const isMobile = detectMobileDevice(window.navigator.userAgent);

function loadedMotion(target) {
  target.style.transform = "translateZ(0)";
}

window.addEventListener("DOMContentLoaded", () => { 

  const section07 = document.querySelector(".section07"); 
  if (isMobile) {
    function scrollHandler() {
      if (isSectionVisible(section07)) {
        var yOffset = window.pageYOffset - section07.offsetTop; // section의 scroll 값을 빼줌
        section07.style.backgroundPosition = "center " + yOffset * 0.1 + "px";
      }
    }
 
    window.addEventListener("scroll", scrollHandler);
  } 
});

$(document).ready(function() {
    var filter = "win16|win32|win64|mac|macintel";
    var device = "pc";
    if (navigator.platform) {
        if (filter.indexOf(navigator.platform.toLowerCase()) < 0) { device = "mobile"; }
    }
 
    var oPriceInfoEl = $('#ec-product-price-info');
    if (oPriceInfoEl.length > 0) {
        var salePriceEl = $('#span_product_price_text');
        percentageCul(oPriceInfoEl, salePriceEl);
    }     
    var mainEl = $(".main") + $(".layout");
    if (mainEl.length > 0) {
      var productListEl = $('.xans-product-listmain, .xans-product-listrecommend, .xans-product-listnew, .xans-product-listnormal');
        for (var i = 0; i < productListEl.length; i++) {
            var prdListEl = productListEl.eq(i).find('.prdList > li');
            for (var j = 0; j < prdListEl.length; j++) {
                var priceEl = prdListEl.eq(j).find('.prdInfo'),
                    salePriceEl = priceEl.find('.xans-product > li').eq(1).find('span:eq(1)');

                if (device == "mobile") {
                    salePriceEl = priceEl.find('.prd_spec >li.price');
                }                percentageCul(priceEl, salePriceEl);
            }
        }
    }
  }
  );
 
$(window).scroll(function(){	

	if($(document).scrollTop() > 0) {
		$('.nav').addClass('fixed');
	} else {
		$('.nav').removeClass('fixed');
	}
	return;
	
});
  
  
 

$(window).scroll(function(){	

	if($(document).scrollTop() > 450) {
		$('.btnTop').fadeIn(200);
	} else {
		$('.btnTop').fadeOut(200);
	}
	return;
	
});

$(function() {
	
	$('.gototop .top').click(function() {
		$('html, body').animate({scrollTop:0}, 'slow');
		return false;
	});
	$('.gototop .bottom').click(function() {
		$('html, body').animate({scrollTop:$(document).height()}, 'slow');
		return false;
	});

});
 

 

 